import React, { useState } from 'react';
import { Loader2, ToggleLeft } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useNotifications } from '../../store/useStore';
import { cn } from '../../lib/cn';

/**
 * Parti dell'app che si possono spegnere.
 *
 * Qui c'era anche un interruttore "Magazzino" che non era collegato a niente:
 * accenderlo non mostrava nessuna schermata in piu'. E' stato tolto, perche'
 * un comando che non fa niente fa credere di aver attivato qualcosa.
 */
export function ModuliCard() {
    const { fattureAttive, salvaFattureAttive } = useSettingsStore();
    const { addNotification } = useNotifications();
    const [salvataggio, setSalvataggio] = useState(false);

    const handleToggle = async (attive: boolean) => {
        setSalvataggio(true);
        try {
            await salvaFattureAttive(attive);
            addNotification({
                type: 'success',
                title: attive ? 'Modulo fatturazione attivato' : 'Modulo fatturazione disattivato'
            });
        } catch (error) {
            console.error('Errore aggiornamento modulo fatturazione:', error);
            addNotification({
                type: 'error',
                title: 'Non salvato',
                message: 'Il database ha rifiutato la modifica. Riprova.'
            });
        } finally {
            setSalvataggio(false);
        }
    };

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center gap-2">
                    <ToggleLeft className="w-5 h-5 text-violet-600" />
                    <CardTitle>Moduli</CardTitle>
                </div>
                <CardDescription>Parti dell&apos;app che si possono spegnere per tutti.</CardDescription>
            </CardHeader>

            <CardContent>
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className="min-w-0">
                        <p className="font-medium text-gray-900">Fatturazione</p>
                        <p className="text-sm text-gray-500">
                            Quando &egrave; spento, le schermate delle fatture spariscono dal menu
                            per tutti i ruoli che le vedevano.
                        </p>
                    </div>
                    <label className="flex flex-shrink-0 cursor-pointer items-center gap-2">
                        <input
                            type="checkbox"
                            checked={fattureAttive}
                            disabled={salvataggio}
                            onChange={(e) => handleToggle(e.target.checked)}
                            className="h-4 w-4 accent-primary-600"
                        />
                        <span
                            className={cn(
                                'text-sm font-medium',
                                fattureAttive ? 'text-emerald-700' : 'text-gray-500'
                            )}
                        >
                            {salvataggio ? <Loader2 className="h-4 w-4 animate-spin" /> : fattureAttive ? 'Attivo' : 'Spento'}
                        </span>
                    </label>
                </div>
            </CardContent>
        </Card>
    );
}

export default ModuliCard;
